import React from 'react'

import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { ListItem, Typography } from '@material-ui/core';
// import {NavContext} from './../../SideBar';

import { updateNavs } from './../../../../../Redux'
import { useDispatch } from 'react-redux';


function ListGeneratorOuter(props) {

    const { page, keyNo, children } = props
    const dispatch = useDispatch()

    const updateNavChange = (val) => {
        val.openState = !val.openState
        console.log("dispatching",val);
        dispatch(updateNavs(val))
    }

    return (


        <>
            <ListItem
                key={keyNo}
                button
                onClick={() => updateNavChange(page)}
            >
                {page.icon}
                {/* {page.openState? 'yes': 'no'} */}
                <Typography variant="h5" style={{ paddingLeft: 8 }}>{page.title}</Typography>
                {/* {page.openState ? <ExpandLess onClick={()=>updateNavChange(page)}/> : <ExpandMore onClick={()=>updateNavChange(page)}/>} */}
                {page.openState ? <ExpandLess /> : <ExpandMore />}

            </ListItem>

            <Collapse in={page.openState} timeout="auto" unmountOnExit style={{ paddingLeft: 8 }}>
                {children}
            </Collapse>
        </>

    )
}


export default ListGeneratorOuter
